import { render, staticRenderFns } from "./CommentForCodeCommentForm.vue?vue&type=template&id=1fe686d7&scoped=true"
import script from "./CommentForCodeCommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForCodeCommentForm.vue?vue&type=script&lang=js"
import style0 from "./CommentForCodeCommentForm.vue?vue&type=style&index=0&id=1fe686d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe686d7",
  null
  
)

export default component.exports